import { Grid, Caption, Button } from '@design-systems/canvas-ui'
import Icon, {
  ArrowLeftIcon,
  MinusCircleIcon,
} from '@design-systems/react-icons'
import UserAvatar from 'users/components/UserAvatar'
import { getUserDisplayName } from 'users/utils/userDisplayHelpers'
import styles from './TeamMemberList.module.css'

type TeamMemberListProps = {
  teamMembers: any[]
  onUndoRemoveMember: (memberId: string) => () => void
  onRemoveMember: (memberId: string) => () => void
}

const TeamMemberList = ({
  teamMembers,
  onUndoRemoveMember,
  onRemoveMember,
}: TeamMemberListProps) => {
  return (
    <Grid.Container direction="column">
      {teamMembers?.map((member: any, index: number) => (
        <Grid.Item key={`${member.id}-${index}`}>
          <Grid.Container align="center" justify="space-between">
            <Grid.Item>
              <UserAvatar
                firstName={member.firstName ?? ''}
                lastName={member.lastName ?? ''}
                lanId={member.lanId ?? ''}
                className={member.isRemoved ? styles['removedAvatar'] : ''}
              />
            </Grid.Item>
            <Grid.Item>
              <Caption
                className={member.isRemoved ? styles['removedText'] : ''}
                below={
                  <span
                    className={member.isRemoved ? styles['removedText'] : ''}
                  >
                    {member.companyName}
                  </span>
                }
              >
                {getUserDisplayName(member.firstName, member.lastName)}
              </Caption>
            </Grid.Item>
            <Grid.Item size={{ xs: true }}>
              <Grid.Container justify="center">
                <Grid.Item>
                  <Caption
                    className={member.isRemoved ? styles['removedText'] : ''}
                  >
                    {member.roles
                      ?.map((role: any) => role.description)
                      .join(', ')}
                  </Caption>
                </Grid.Item>
              </Grid.Container>
            </Grid.Item>
            <Grid.Item>
              {member.isRemoved && (
                <Button
                  variant="secondary"
                  onClick={onUndoRemoveMember(member.id)}
                >
                  <Icon svg={ArrowLeftIcon} />
                  Undo
                </Button>
              )}
              {!member.isRemoved && (
                <Button
                  variant="destructive"
                  onClick={onRemoveMember(member.id)}
                >
                  <Icon svg={MinusCircleIcon} />
                  Remove
                </Button>
              )}
            </Grid.Item>
          </Grid.Container>
        </Grid.Item>
      ))}
    </Grid.Container>
  )
}

export default TeamMemberList
